import { render, staticRenderFns } from "./KS2.vue?vue&type=template&id=3c103cc5"
import script from "./KS2.vue?vue&type=script&lang=js"
export * from "./KS2.vue?vue&type=script&lang=js"
import style0 from "./KS2.vue?vue&type=style&index=0&id=3c103cc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports